import { useMemo } from 'react';
import { ADD_USER } from '../../../../../../constants/features';
import { ActivationTiming } from '../../manage-subscription-drawer/constants';
import {
  useGetCurrentAdditionalUserQuantity,
  useGetAdditionalUsersCountForPromoPlan,
} from './use-get-additional-users-count-for-promo-plan';

const createAdditionalUsersAddOn = (additionalUsers) => ({
  code: ADD_USER,
  quantity: additionalUsers,
  activationTiming: ActivationTiming.IMMEDIATELY,
});

/**
 * Returns the AddOn shaped object
 * @param {number} newAdditionalUserCount
 * @returns {object}
 */
const getAddOn = (newAdditionalUserCount) => {
  const doesNewPlanLimitCoverTotalUserCount = newAdditionalUserCount <= 0;
  return createAdditionalUsersAddOn(doesNewPlanLimitCoverTotalUserCount ? 0 : newAdditionalUserCount);
};

/**
 * Pushes the 'add_user' AddOn to the provided array if it doesn't already exist in it
 * @param {object} additionalUserAddOn
 * @param {object[]} addOnsArray
 * @returns {object[]}
 */
export const safelyAppendAdditionalUserAddOn = (additionalUserAddOn, addOnsArray) => {
  if (addOnsArray.some((addOn) => addOn.code === additionalUserAddOn.code)) {
    return addOnsArray;
  }

  return addOnsArray.push(additionalUserAddOn);
};

/**
 *
 * @returns {{ additionalUserAddOn: object, shouldActOnAdditionalUsers: boolean }}
 */
export const useGetAdditionalUsersAddOn = () => {
  const currentAdditionalUserCount = useGetCurrentAdditionalUserQuantity();
  const newAdditionalUserCount = useGetAdditionalUsersCountForPromoPlan();
  const additionalUserAddOn = getAddOn(newAdditionalUserCount);

  const shouldActOnAdditionalUsers = currentAdditionalUserCount > 0;

  return useMemo(
    () => ({
      additionalUserAddOn,
      shouldActOnAdditionalUsers,
    }),
    [additionalUserAddOn, shouldActOnAdditionalUsers],
  );
};
